import { IconProps } from '../Icon.types';

export const EnergyImportantIcon = ({ width, height, color }: IconProps) => {
  return (
    <svg viewBox="0 0 20 20" width={width} height={height}>
      <g clipPath="url(#clip0_14883_174521)">
        <rect width="20" height="20" rx="10" fill="white" />
        <circle cx="10" cy="10" r="10" fill={color} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2839 4.57822C12.0208 5.3 11.8 6.3 11.1362 6.99807L9.5 8.5H13.9385C15.8325 8.5 16.7203 10.6283 15.302 11.8834L11.1362 15.5695C10.4271 16.1969 9.34359 16.1308 8.71608 15.4218C8.08857 14.7128 8.05 13.8 8.86379 13.0019L10.5 11.5H6.0615C4.16747 11.5 3.27969 9.37166 4.69805 8.11662L8.86379 4.43053C9.57288 3.80309 10.6564 3.86921 11.2839 4.57822Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_14883_174521">
          <rect width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
